import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUserService } from '../../shared/CurrentUser.service';
import { QuickLinksService } from '../../shared/services/quick-links.service';
import { AppInfoService } from '../../singletons/app-info.service';
import { IQuickLinkGroups, IQuickLinks } from '../../shared/quicklinks/IQuickLinks';

import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  standalone: true,
  imports: [MatListModule],
  providers: [CurrentUserService, QuickLinksService, AppInfoService]
})
export class HomeComponent implements OnInit {
  private router = inject(Router);
  private quickLinksService = inject(QuickLinksService);
  private currentUserService = inject(CurrentUserService);
  private service = inject(AppInfoService);

  private FtmsLink: string;

  protected MyLinkGroups = signal<IQuickLinkGroups[]>([]);

  ngOnInit() {
    this.currentUserService.GetApiUser().subscribe((user) => this.MyLinkGroups.set(this.quickLinksService.getQuickLinkGroups(user)));
    this.service.getAppStartupInfo().subscribe((info) => {
      if (info)
        this.FtmsLink = info.FtmsLink;
    });
  }

  private navigateToFtms(route: string) {
    window.open(this.FtmsLink + route, '_blank').focus();
  }

  protected navigateTo(quickLink: IQuickLinks) {
    if (quickLink.isFTMSLink) {
      this.navigateToFtms(quickLink.route);
    } else {
      if (quickLink.navigationExtraState != undefined)
        this.router.navigateByUrl(quickLink.route, {
          state: quickLink.navigationExtraState
        });
      else
        this.router.navigateByUrl(quickLink.route);
    }
  }
}
